var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 132,
    viewBox: "0 0 138 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.7586 118.633C98.7586 118.633 121.459 95.9333 121.459 67.8333C121.459 39.7333 98.6586 17.0333 70.7586 17.0333C42.7586 17.0333 20.0586 39.7333 20.0586 67.8333C20.0586 95.9333 42.7586 118.633 70.7586 118.633Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.609 100.61C126.873 100.61 128.709 98.7745 128.709 96.5102C128.709 94.2458 126.873 92.4102 124.609 92.4102C122.344 92.4102 120.509 94.2458 120.509 96.5102C120.509 98.7745 122.344 100.61 124.609 100.61Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.609 84.6101C132.155 84.6101 133.409 83.3565 133.409 81.8101C133.409 80.2637 132.155 79.0101 130.609 79.0101C129.062 79.0101 127.809 80.2637 127.809 81.8101C127.809 83.3565 129.062 84.6101 130.609 84.6101Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.759 34.4334C24.3054 34.4334 25.559 33.1798 25.559 31.6334C25.559 30.087 24.3054 28.8334 22.759 28.8334C21.2126 28.8334 19.959 30.087 19.959 31.6334C19.959 33.1798 21.2126 34.4334 22.759 34.4334Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.65898 88.4333C8.53086 88.4333 10.859 86.1052 10.859 83.2333C10.859 80.3614 8.53086 78.0333 5.65898 78.0333C2.7871 78.0333 0.458984 80.3614 0.458984 83.2333C0.458984 86.1052 2.7871 88.4333 5.65898 88.4333Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1203 86.2513H65.8531C63.2424 86.2513 61.0439 88.6597 61.0439 91.5196V97.6909C61.0439 104.013 65.7157 109.13 71.4867 109.13C77.2577 109.13 81.9294 104.013 81.9294 97.6909V91.5196C81.9294 88.5092 79.731 86.2513 77.1203 86.2513Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8535 27.1171V26.0651C64.8535 22.9058 67.3268 20.4332 70.4871 20.4332C73.6474 20.4332 76.1207 22.9058 76.1207 26.0651V27.1173C87.1451 29.6676 95.3569 39.5409 95.3569 51.3398V54.4992C95.3569 81.1475 115.418 98.5926 115.418 98.5926H25.418C25.418 98.5926 45.6164 81.1475 45.6164 54.4992V51.3398C45.6164 39.5406 53.8286 29.667 64.8535 27.1171Z",
    fill: "url(#paint0_linear_0_4810)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.044 65.3508C56.6089 65.3508 53.7234 63.153 52.6242 59.9937C52.3494 59.3069 52.7616 58.6201 53.4486 58.3453C54.1356 58.0706 54.8226 58.4827 55.0974 59.1695C55.7845 61.2299 57.8455 62.7409 60.044 62.7409C62.2425 62.7409 64.3036 61.3673 64.9906 59.1695C65.2654 58.4827 65.9524 58.0706 66.6394 58.3453C67.3265 58.6201 67.7387 59.3069 67.4639 59.9937C66.3646 63.2904 63.4791 65.3508 60.044 65.3508Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7921 65.3508C77.3569 65.3508 74.4714 63.153 73.3722 59.9937C73.0974 59.3069 73.5096 58.6201 74.1966 58.3453C74.8837 58.0706 75.5707 58.4827 75.8455 59.1695C76.5325 61.2299 78.5936 62.7409 80.7921 62.7409C82.9905 62.7409 85.0516 61.3673 85.7386 59.1695C86.0134 58.4827 86.7005 58.0706 87.3875 58.3453C88.0745 58.6201 88.4867 59.3069 88.2119 59.9937C87.1127 63.2904 84.2272 65.3508 80.7921 65.3508Z",
    fill: "currentColor"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M70.4865 82.1695C72.2319 82.1695 73.6468 80.755 73.6468 79.0102C73.6468 77.2653 72.2319 75.8508 70.4865 75.8508C68.7411 75.8508 67.3262 77.2653 67.3262 79.0102C67.3262 80.755 68.7411 82.1695 70.4865 82.1695Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4213 4.66212V0.0124512H105.391V4.66212L93.1295 19.4565H105.603V24.1062H86.7871V19.4565L99.0491 4.66212H87.4213Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.22 39.5347V36.5758H113.847V39.5347L106.025 49.0454H114.059V52.0043H101.797V49.0454L109.619 39.5347H102.22Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4810",
    x: 3.41797,
    y: 9.43323,
    width: 134,
    height: 122.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4810",
    x1: 70.3886,
    y1: 18.6253,
    x2: 70.3886,
    y2: 99.4352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/EmptyNotification.88153a3f.svg";
export { ForwardRef as ReactComponent };